import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteClassification } from "@/api/classifications-api";

import { CLASSIFICATIONS_QUERY_KEY } from "./use-classifications";

export const useDeleteClassification = (classificationId: string | undefined) => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, void>(
		{
			mutationFn: () => {
				if (!classificationId) {
					throw new Error("Classification ID is required");
				}

				return deleteClassification(classificationId);
			},
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: [CLASSIFICATIONS_QUERY_KEY] });
			},
		},
		queryClient,
	);
};
